import React from 'react';
import styled from 'styled-components';
import shortid from 'shortid';

import css from 'css';

import Tooltip from 'partials/Tooltip';

const Wrapper = styled.div`
    position: relative;

    input {
        border: 1px solid #000;
        color: ${css.colors.main};
        outline: none;
        border-radius: 0;
        padding:10px;
        font-size:16px;
        height:40px;
        width: 200px;

        &::placeholder {
            color: ${css.colors.main};
            opacity:.6;
        }
    }

    .input-header {
        display: flex;
        justify-content: space-between;
    }

    label {
        display:block;
        margin-bottom:5px;
    }

    ${props=> props.error ? `
        input {
            border: 1px solid ${css.colors.red};
        }

        &:after {
            content: '${props.error}';
            color: ${css.colors.red};
            display:block;
            position: absolute;
            left: 0;
            bottom: -25px;
        }
    ` : ``}
`

export default ({ label, error, tooltipTitle, tooltipContent, ...rest}) => {
    const id = shortid.generate();

    return (
        <Wrapper error={error} className={['input-wrapper', error ? 'error' : ''].join(' ')}>
            <div className="input-header">
                {label && <label htmlFor={id}>{label}</label> }
                {tooltipTitle && <Tooltip title={tooltipTitle} content={tooltipContent}/>}      
            </div>
            <input id={id} type="text" {...rest} />
        </Wrapper>
    );
}


// WEBPACK FOOTER //
// ./src/partials/formElements/Input.js